import { PostAdd } from '@mui/icons-material';
import { useTranslation } from 'react-i18next'; // styled component
import FlexBetween from 'components/flexbox/FlexBetween';
import { Button, styled, Typography } from '@mui/material';
// import SearchInput from "components/input-fields/SearchInput";

const StyledFlexBox = styled(FlexBetween)(({ theme }) => ({
    flexWrap: 'wrap',
    marginBottom: 20,
    [theme.breakpoints.down(500)]: {
        width: '100%',
        '& .MuiInputBase-root': {
            maxWidth: '100%',
        },
        '& .MuiButton-root': {
            width: '100%',
            marginTop: 15,
        },
    },
})); // -----------------------------------------------------------

// -----------------------------------------------------------
const ListHeader = ({
    handleClick,
    // setSearchValue,
    buttonText = 'Add New Registration',
}) => {
    const { t } = useTranslation();
    return (
        <StyledFlexBox>
            <Typography
                sx={{
                    fontSize: 30,
                    fontWeight: 650,
                }}
            >
                Registration Data
            </Typography>
            {/* <SearchInput bordered={false} placeholder="Search..." onChange={e => setSearchValue(e.target.value)} /> */}

            <Button
                variant="contained"
                onClick={handleClick}
                startIcon={<PostAdd />}
            >
                {t(buttonText)}
            </Button>
        </StyledFlexBox>
    );
};

export default ListHeader;
